import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { uniq } from 'utils/utils';
import { canDisplayAdvice, sortByPayers } from 'works/utils';
import { DEFAULT_LANGUAGE } from 'constants/LanguageConstants';
import { fetchEntitySuccess } from 'modules/entity/actions';
import { answerWorksSuccess } from 'modules/entity/subEntities/intervention/actions/works';

/**
 * @typedef {Array<string>} Ids
 */

/**
 * @typedef {{
 *  [type:string]: Ids
 * }} IdsState
 */

/** @type {IdsState} */
const initialState = {};

/**
 *
 * @param {IdsState} _
 * @param {{payload: import('modules/entity/subEntities/intervention/types').Intervention}} intervention
 * @returns {IdsState}
 */
const updateFromIntervention = (_, { payload: intervention }) => {
  const { checklists = [], displayItemsWithoutPrice, customerInfo, dealer, payers = [] } = intervention;
  return checklists.reduce(
    (acc, { type, items = [] }) => ({
      ...acc,
      [type]: uniq([
        ...(acc?.[type] ?? []),
        ...items.flatMap(({ advices = [] }) =>
          advices
            .toSorted(sortByPayers(payers, customerInfo?.language, dealer?.customerDefaultLanguage ?? DEFAULT_LANGUAGE))
            .reduce((adviceAcc, advice) => {
              // Do not delete, we receive advices to show only in control report
              if (canDisplayAdvice({ ...advice, checklistType: type }, displayItemsWithoutPrice)) {
                adviceAcc.push(advice.adviceId);
              }
              return adviceAcc;
            }, [])),
      ]),
    }),
    initialState
  );
};

export default createReducer(initialState, (builder) => {
  builder.addMatcher(isAnyOf(fetchEntitySuccess.match, answerWorksSuccess.match), updateFromIntervention);
});
